import React, { useState, useEffect } from "react";
import {
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { Archive } from "../../../@types/archive";
import { chevronBack, closeOutline, documentOutline } from "ionicons/icons";
import { useDispatch } from "react-redux";
import api from "../../../utils/api";
import "./ArchiveItem.css";
import deleteArchive from "../../../store/paymentNoticeDetail/actions/deleteArchive";

export const ArchiveItem: React.FC<{ archive: Archive; editable: boolean }> = ({
  archive,
  editable,
}) => {
  const dispatch = useDispatch();
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchFile = async () => {
      if (archive.id) {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${api.baseURL}archive/${archive.id}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setFileUrl(url);
          } else {
            console.error('Error fetching file:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchFile();
  }, [archive.id]);

  return (
    <>
      <IonCard
        style={{
          scrollSnapAlign: "center",
          minWidth: "260px",
          width: "260px",
          maxWidth: "90%",
          marginTop: "16px",
          marginLeft: "0px",
        }}
        onClick={() => setShowArchiveModal(true)}
        button
      >
        <IonItem lines="none" color="secondary">
          <IonIcon slot="start" icon={documentOutline}></IonIcon>
          <IonLabel>
            <strong>{archive.filename}</strong>
          </IonLabel>
          <IonButtons slot="end">
            {editable && (
              <IonButton
                onClick={() => dispatch(deleteArchive(archive.id || ""))}
              >
                <IonIcon icon={closeOutline}></IonIcon>
              </IonButton>
            )}
          </IonButtons>
        </IonItem>
      </IonCard>
      <IonModal
        isOpen={showArchiveModal}
        onDidDismiss={() => {
          setShowArchiveModal(false);
        }}
      >
        <IonHeader translucent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => setShowArchiveModal(false)}>
                <IonIcon icon={chevronBack}></IonIcon>
              </IonButton>
            </IonButtons>
            <IonTitle>Adjunto</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {[".png", ".jpeg"].includes(archive.extension || "") && fileUrl && (
            <img
              alt=""
              src={fileUrl}
              style={{
                objectFit: "contain",
                height: "100%",
                width: "100%",
                backgroundColor: "rgb(197 197 197)",
              }}
              className="zoom"
            />
          )}
          {archive.extension === ".pdf" && fileUrl && (
            <object
              data={fileUrl}
              type="application/pdf"
              style={{ width: "100%", height: "100%" }}
            >
              Documento
            </object>
          )}
        </IonContent>
      </IonModal>
    </>
  );
};